async function registerServiceWorker() {
  try {
    await navigator.serviceWorker.register("/sw.js");
  } catch (e) {
    console.error("ServiceWorker registration failed", e);
  }
}

export function installPwa() {
  const isInstalledPwa =
    window.matchMedia("(display-mode: window-controls-overlay)").matches ||
    window.matchMedia("(display-mode: standalone)").matches;

  registerServiceWorker();

  if (!isInstalledPwa) {
    window.addEventListener("beforeinstallprompt", (e: any) => {
      // e.preventDefault();
      // e.prompt();
    });
  }
}
